interface Props {
  cells?: number;
  height?: number;
}

export function SkeletonRow({ cells = 5, height = 14 }: Props): JSX.Element {
  return (
    <tr>
      {Array.from({ length: cells }).map((_, i) => (
        <td key={i}>
          <div className="sk" style={{ height, width: `${50 + Math.random() * 40}%` }} />
        </td>
      ))}
    </tr>
  );
}
